module.exports = __webpack_public_path__ + "static/img/kftp3.83b8f6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/joinus/kftp3.png
// module id = D6bN
// module chunks = 1